var readmore = require('readmore-js');

export default {
  init() {
    // We only want to use the truncation stuff on the main branch page
    if (jQuery('body').hasClass('government-home')) {
      console.log('test2');
      var that = this;
      jQuery(window).load(setTimeout(function(){
        that.truncateBrowseSidebar();
        that.truncateContentArea();
      }, 7000));
    }
  },
  truncateBrowseSidebar() {
    var $listItems = jQuery('.sidebar__browse .sidebar__content li'),
        overflowListItems = [];
    if ( $listItems.length > 8 ) {
      $listItems.hide().slice(0, 8).show();
      $listItems.parent('div').append('<li class="view-all-toggle">Show All...</li>');
      $('.view-all-toggle').on('click', function(e) {
        $(this).remove();
        $listItems.show();
      });
    }
  },
  truncateContentArea() {
    var paragraphs = jQuery('.hamilton--toggle-content-wrapper').children(),
        sidebarElements = jQuery('.sidebar__contact').children(),
        maxHeight = 0,
        readMorePosition = 0;

    $.each( sidebarElements, function(i,v){
      maxHeight += $(this).outerHeight();
    });

    maxHeight = maxHeight > 350 ? maxHeight : 350;

    $.each(paragraphs, function(i,v) {
      if (readMorePosition > maxHeight ) {
        $('.hamilton--toggle-content-wrapper').readmore({
          collapsedHeight: readMorePosition,
          moreLink: '<a href="#" class="readmore">Show more</a>',
          lessLink: '<a href="#" class="readmore">Show less</a>'
        });
        return false;
      }
      readMorePosition += $(this).outerHeight();
    });
  },
  countLines(selector) {
    var $content = $(selector),
        $paragraphs = $content.find('p'),
        height, lineHeight, lines = 0;
    $.each($paragraphs, function(i,v){
      height = $(this).height();
      lineHeight = $(this).css('line-height');
      lines += height/lineHeight;
    });
    return lines;
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/government.js